module.exports = __webpack_public_path__ + "static/media/flop_landing_screen.1df019c4.png";